<template>
  <div id="app">
    <div v-if="!currentUser && $route.path === '/login'">
      <router-view />
    </div>
    <el-container v-else class="app-container">
      <el-aside :width="sidebarCollapsed ? '64px' : '200px'" class="app-aside" :class="{ collapsed: sidebarCollapsed }">
        <div class="logo-area">
          <img v-if="systemLogo" :src="getImageUrl(systemLogo)" class="logo-img" @error="systemLogo = ''" />
          <i v-else class="el-icon-s-goods logo-icon"></i>
          <span v-if="!sidebarCollapsed" class="logo-text">{{ systemName }}</span>
        </div>
        <el-menu
          :default-active="activeMenu"
          class="aside-menu"
          :background-color="sidebarBg"
          text-color="rgba(255,255,255,0.7)"
          active-text-color="#fff"
          router
          unique-opened
          :collapse="sidebarCollapsed"
          :collapse-transition="false"
        >
          <el-menu-item index="/dashboard">
            <i class="el-icon-s-home"></i>
            <span>首页</span>
          </el-menu-item>
          <template v-for="menu in visibleMenus">
            <el-submenu v-if="menu.children && menu.children.length" :key="'group-' + menu.id" :index="'group-' + menu.id">
              <template slot="title">
                <i :class="menu.icon"></i>
                <span>{{ menu.title }}</span>
              </template>
              <template v-for="child in menu.children">
                <el-submenu v-if="child.children && child.children.length" :key="'group-' + child.id" :index="'group-' + child.id">
                  <template slot="title">
                    <i :class="child.icon"></i>
                    <span>{{ child.title }}</span>
                  </template>
                  <el-menu-item v-for="leaf in child.children" :key="leaf.index" :index="leaf.index">
                    <i :class="leaf.icon"></i>
                    <span>{{ leaf.title }}</span>
                  </el-menu-item>
                </el-submenu>
                <el-menu-item v-else :key="child.index" :index="child.index">
                  <i :class="child.icon"></i>
                  <span>{{ child.title }}</span>
                </el-menu-item>
              </template>
            </el-submenu>
            <el-menu-item v-else :key="menu.index" :index="menu.index">
              <i :class="menu.icon"></i>
              <span>{{ menu.title }}</span>
            </el-menu-item>
          </template>
        </el-menu>
        <div class="aside-footer" @click="handleLogout">
          <i class="el-icon-switch-button"></i>
          <span v-if="!sidebarCollapsed">退出登录</span>
        </div>
      </el-aside>
      <el-container style="flex-direction: column;">
        <el-header class="app-header">
          <div class="header-left">
            <i class="header-fold-btn" :class="sidebarCollapsed ? 'el-icon-s-unfold' : 'el-icon-s-fold'" @click="sidebarCollapsed = !sidebarCollapsed"></i>
            <h1 class="header-title">{{ pageTitle }}</h1>
          </div>
          <div class="header-right" v-if="currentUser">
            <el-avatar :size="36" style="background: var(--theme-primary); margin-right: 10px; font-size: 16px">{{ currentUser.name ? currentUser.name.charAt(0) : 'U' }}</el-avatar>
            <span class="user-name">{{ currentUser.name }}</span>
            <el-tag size="mini" :type="currentUser.role === 'super_admin' ? 'danger' : currentUser.role === 'admin' ? 'warning' : 'success'" style="margin-left: 8px">{{ roleName }}</el-tag>
          </div>
        </el-header>
        <el-main class="app-main">
          <transition name="fade" mode="out-in">
            <router-view />
          </transition>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      currentUser: null,
      sidebarCollapsed: false,
      systemName: '存货宝',
      systemLogo: '',
      sidebarBg: '#2793FF',
      primaryColor: '#2793FF',
      compact: false,
      // 硬编码 fallback：API 拉取失败时用这一份保证侧边栏不空
      // fallbackMenus: [
      //   { id: 1, parentId: null, index: '/user', title: '账号管理', icon: 'el-icon-user', roles: ['super_admin'] },
      //   { id: 2, parentId: null, index: '/menu-management', title: '菜单管理', icon: 'el-icon-menu', roles: ['super_admin'] },
      //   { id: 19, parentId: null, index: '', title: '客户', icon: 'el-icon-s-custom', roles: ['super_admin', 'admin'] },
      //   { id: 140, parentId: 19, index: '/customer-label', title: '客户标签管理', icon: 'el-icon-collection-tag', roles: ['super_admin'] },
      //   { id: 141, parentId: 19, index: '/customer-category', title: '客户类别管理', icon: 'el-icon-files', roles: ['super_admin'] },
      //   { id: 145, parentId: 19, index: '/applicable-type', title: '试用类型管理', icon: 'el-icon-finished', roles: ['super_admin', 'admin'] },
      //   { id: 142, parentId: null, index: '/forbidden-list', title: '禁售名单', icon: 'el-icon-warning-outline', roles: ['super_admin', 'admin'] },
      //   { id: 143, parentId: null, index: '/outbound-type', title: '出库类型管理', icon: 'el-icon-set-up', roles: ['super_admin'] },
      //   { id: 146, parentId: null, index: '/gift-recipient', title: '礼品名单管理', icon: 'el-icon-present', roles: ['super_admin', 'admin', 'salesman'] },
      //   { id: 3, parentId: null, index: '/product', title: '产品管理', icon: 'el-icon-s-grid', roles: ['super_admin', 'admin'] },
      //   { id: 4, parentId: null, index: '/gift', title: '礼品管理', icon: 'el-icon-present', roles: ['super_admin', 'admin'] },
      //   { id: 5, parentId: null, index: '/category', title: '分类管理', icon: 'el-icon-collection-tag', roles: ['super_admin', 'admin'] },
      //   { id: 6, parentId: 19, index: '/customer', title: '客户管理', icon: 'el-icon-s-custom', roles: ['super_admin', 'admin'] },
      //   { id: 7, parentId: null, index: '/product-inventory', title: '产品库房', icon: 'el-icon-s-operation', roles: ['super_admin', 'admin'] },
      //   { id: 8, parentId: null, index: '/gift-inventory', title: '礼品库房', icon: 'el-icon-box', roles: ['super_admin', 'admin'] },
      //   // 订单管理（一级 + 两个子菜单）
      //   { id: 100, parentId: null, index: '/order', title: '订单管理', icon: 'el-icon-shopping-cart-2', roles: ['super_admin', 'admin'] },
      //   { id: 101, parentId: 100, index: '/sales-order', title: '销售订单', icon: 'el-icon-document-copy', roles: ['super_admin', 'admin'] },
      //   { id: 102, parentId: 100, index: '/vip-order', title: '尊贵卡订单', icon: 'el-icon-medal', roles: ['super_admin', 'admin'] },
      //   { id: 9, parentId: 19, index: '/customer-alert', title: '客户提示', icon: 'el-icon-warning', roles: ['super_admin', 'admin'] },
      //   { id: 10, parentId: null, index: '/user-task', title: '个人待办', icon: 'el-icon-tickets', roles: ['super_admin', 'admin', 'salesman'] },
      //   { id: 300, parentId: null, index: '/report', title: '报表统计', icon: 'el-icon-data-line', roles: ['super_admin', 'admin', 'salesman'] },
      //   { id: 11, parentId: null, index: '/operation-log', title: '操作日志', icon: 'el-icon-document', roles: ['super_admin'] },
      //   { id: 12, parentId: null, index: '/data-backup', title: '数据备份', icon: 'el-icon-folder', roles: ['super_admin'] },
      //   { id: 13, parentId: null, index: '/system-config', title: '系统设置', icon: 'el-icon-setting', roles: ['super_admin'] }
      // ],
      fallbackMenus: [],
      menus: []
    }
  },
  computed: {
    visibleMenus() {
      if (!this.currentUser || !this.currentUser.role) return []
      const role = this.currentUser.role
      const byRole = this.menus.filter(m => m.roles.includes(role))
      const buildTree = (parentId) => byRole
        .filter(m => (m.parentId || null) === parentId)
        .map(m => {
          const kids = buildTree(m.id)
          return kids.length ? { ...m, children: kids } : { ...m }
        })
      return buildTree(null)
    },
    activeMenu() { return this.$route.path || '/dashboard' },
    roleName() {
      const map = { 'super_admin': '超级管理员', 'admin': '行政管理员', 'salesman': '业务员' }
      return this.currentUser ? (map[this.currentUser.role] || '') : ''
    },
    pageTitle() {
      const path = this.$route.path
      if (path === '/dashboard') return '首页'
      const menu = this.menus.find(m => m.index === path)
      return menu ? menu.title : '存货宝'
    }
  },
  mounted() {
    this.loadUserInfo()
    this.loadSystemConfig()
    this.loadMenus()
    this.$root.$on('config-updated', () => { this.loadSystemConfig() })
    this.$root.$on('menus-updated', () => { this.loadMenus() })
  },
  beforeDestroy() {
    this.$root.$off('config-updated')
    this.$root.$off('menus-updated')
  },
  watch: { $route: { handler() { this.loadUserInfo() }, immediate: true } },
  methods: {
    loadUserInfo() {
      const s = sessionStorage.getItem('user')
      this.currentUser = s ? JSON.parse(s) : null
    },
    loadSystemConfig() {
      import('./api/api').then(({ configApi }) => {
        configApi.getConfigs().then(res => {
          if (res.data) {
            this.systemName = res.data.system_name || '存货宝'
            this.systemLogo = res.data.system_logo || ''
            document.title = this.systemName
            this.applyTheme({
              primary: res.data.theme_primary_color || '#2793FF',
              sidebar: res.data.theme_sidebar_color || '#2793FF',
              compact: res.data.theme_compact === '1' || res.data.theme_compact === 'true'
            })
          }
        }).catch(() => {})
      })
    },
    applyTheme({ primary, sidebar, compact }) {
      this.primaryColor = primary
      this.sidebarBg = sidebar
      this.compact = !!compact
      const root = document.documentElement
      root.style.setProperty('--theme-primary', primary)
      root.style.setProperty('--theme-sidebar-bg', sidebar)
      document.body.classList.toggle('theme-compact', !!compact)
    },
    loadMenus() {
      import('./api/api').then(({ menuApi }) => {
        menuApi.getEnabled().then(res => {
          const list = Array.isArray(res.data) ? res.data : []
          if (list.length === 0) {
            this.menus = this.fallbackMenus
            return
          }
          this.menus = list.map(m => ({
            id: m.id,
            parentId: m.parentId || null,
            index: m.path,
            title: m.title,
            icon: m.icon || '',
            roles: (m.roleCodes || '').split(',').map(s => s.trim()).filter(Boolean)
          }))
        }).catch(() => {
          this.menus = this.fallbackMenus
        })
      })
    },
    getImageUrl(url) {
      if (!url) return ''
      if (url.startsWith('http') || url.startsWith('data:')) return url
      return 'https://chb.bjzkbh.com' + url
    },
    handleLogout() {
      this.$confirm('确定要退出登录吗？', '提示', { type: 'warning' }).then(() => {
        sessionStorage.removeItem('token')
        sessionStorage.removeItem('user')
        this.$router.push('/login')
      }).catch(() => {})
    }
  }
}
</script>

<style>
* { margin: 0; padding: 0; box-sizing: border-box; }
html, body { height: 100%; }
html { font-size: 16px; }
#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  -webkit-font-smoothing: antialiased;
  color: #1A2A3A;
  height: 100%;
  font-size: 16px;
}

/* CSS variables for theme - 老年企业版 蓝白色 */
:root {
  --theme-primary: #2793FF;
  --theme-primary-light: #E3F2FD;
  --theme-primary-hover: #0F7CE0;
  --theme-sidebar-bg: #2793FF;
  --theme-sidebar-active: #0071E2;
  --theme-bg: #F5F8FC;
  --theme-text: #1A2A3A;
  --theme-text-sub: #506580;
  --theme-border: #D6E1EE;
}

/* Layout */
.app-container { height: 100vh; }
.app-aside {
  background: var(--theme-sidebar-bg);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 2px 0 10px rgba(39,147,255,0.30);
}
.logo-area {
  height: 68px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid rgba(255,255,255,0.25);
  background: rgba(255,255,255,0.12);
}
.logo-img { width: 36px; height: 36px; object-fit: contain; margin-right: 10px; border-radius: 6px; background: #fff; padding: 2px; }
.logo-icon { font-size: 30px; color: #fff; margin-right: 10px; }
.logo-text { font-size: 22px; font-weight: 700; color: #fff; letter-spacing: 3px; text-shadow: 0 1px 2px rgba(13,71,161,0.35); }
.aside-menu {
  flex: 1;
  border-right: none !important;
  overflow-x: hidden;
  overflow-y: auto;
  background: var(--theme-sidebar-bg) !important;
}
.aside-menu .el-menu-item,
.aside-menu .el-submenu__title {
  height: 52px;
  line-height: 52px;
  font-size: 16px;
  transition: all 0.25s;
  color: #fff !important;
}
.aside-menu .el-menu-item:hover,
.aside-menu .el-submenu__title:hover { background: rgba(255,255,255,0.20) !important; color: #fff !important; }
.aside-menu .el-menu-item.is-active {
  background: var(--theme-sidebar-active) !important;
  color: #fff !important;
  font-weight: 700;
}
.aside-menu .el-submenu .el-menu-item { background: transparent !important; padding-left: 48px !important; }
.aside-menu .el-submenu .el-menu-item:hover { background: rgba(255,255,255,0.20) !important; }
.aside-menu .el-submenu .el-menu-item.is-active { background: var(--theme-sidebar-active) !important; }
.aside-menu i,
.aside-menu .el-menu-item i,
.aside-menu .el-submenu__title i,
.aside-menu .el-menu-item.is-active i,
.aside-menu .el-submenu.is-active > .el-submenu__title i { color: #fff !important; }

/* Compact mode: reduce spacing across the admin */
body.theme-compact .app-main { padding: 12px; }
body.theme-compact .el-card__header { padding: 10px 14px; }
body.theme-compact .el-card__body { padding: 14px; }
body.theme-compact .el-form-item { margin-bottom: 10px; }
body.theme-compact .app-header { height: 48px !important; }
body.theme-compact .aside-menu .el-menu-item,
body.theme-compact .aside-menu .el-submenu__title { height: 40px; line-height: 40px; font-size: 14px; }
.aside-menu .el-menu-item i { margin-right: 8px; font-size: 16px; }
.aside-footer {
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255,255,255,0.5);
  cursor: pointer;
  border-top: 1px solid rgba(255,255,255,0.1);
  font-size: 15px;
  transition: all 0.3s;
}
.aside-footer:hover { color: #fff; background: rgba(255,255,255,0.08); }
/* Collapse mode */
.app-aside.collapsed .aside-menu:not(.el-menu--collapse) { width: 64px; }
.app-aside.collapsed .logo-area { padding: 0; }
.header-fold-btn {
  font-size: 22px;
  margin-right: 12px;
  cursor: pointer;
  color: #303133;
  transition: color 0.2s;
}
.header-fold-btn:hover { color: var(--theme-primary); }
.aside-footer i { margin-right: 6px; }

/* Header */
.app-header {
  background: #fff;
  border-bottom: 2px solid var(--theme-primary-light);
  padding: 0 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 8px rgba(39,147,255,0.06);
  height: 68px !important;
  z-index: 10;
}
.header-left { display: flex; align-items: center; }
.header-title { font-size: 23px; font-weight: 700; color: var(--theme-primary); letter-spacing: 1px; margin: 0; }
.header-right { display: flex; align-items: center; }
.user-name { font-size: 17px; color: var(--theme-text); font-weight: 600; }

/* Main */
.app-main {
  background: var(--theme-bg);
  padding: 24px;
  overflow-y: auto;
}

/* Transition */
.fade-enter-active, .fade-leave-active { transition: opacity 0.2s; }
.fade-enter, .fade-leave-to { opacity: 0; }

/* Global card styles */
.el-card {
  border-radius: 10px;
  border: 1px solid var(--theme-border);
  box-shadow: 0 4px 16px rgba(39,147,255,0.08) !important;
  background: #fff;
}
.el-card__header {
  padding: 16px 22px;
  border-bottom: 2px solid var(--theme-primary-light);
  font-size: 18px;
  font-weight: 700;
  color: var(--theme-primary);
  background: linear-gradient(180deg, #FAFCFE 0%, #fff 100%);
}

/* Global table styles */
.el-table {
  border-radius: 8px;
  overflow: hidden;
  font-size: 15px !important;
  color: var(--theme-text) !important;
}
.el-table th {
  background: var(--theme-primary-light) !important;
  color: var(--theme-primary) !important;
  font-weight: 700;
  font-size: 15px;
  text-align: center !important;
  height: 48px;
}
.el-table td { font-size: 15px; text-align: center !important; padding: 10px 0 !important; }
.el-table .cell { text-align: center; line-height: 1.6; }
.el-table--striped .el-table__body tr.el-table__row--striped td { background: #F5F9FD; }
.el-table__body tr:hover > td { background: var(--theme-primary-light) !important; }

/* Global pagination */
.el-pagination { text-align: right; padding: 12px 0 4px; }

/* Global dialog */
.el-dialog { border-radius: 10px; }
.el-dialog__header { padding: 16px 20px; border-bottom: 1px solid #f0f0f0; }
.el-dialog__title { font-size: 17px; font-weight: 600; }
.el-dialog__body { padding: 20px; }
.el-dialog__footer { padding: 12px 20px; border-top: 1px solid #f0f0f0; }

/* Global tag */
.el-tag { border-radius: 4px; }

/* Global button refinements - 老年版加大按钮 */
.el-button {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  vertical-align: middle !important;
  text-align: center !important;
  line-height: 1 !important;
  font-size: 15px !important;
  font-weight: 500;
}
.el-button--mini { border-radius: 6px; height: 32px; padding: 0 14px !important; font-size: 14px !important; }
.el-button--small { border-radius: 6px; height: 36px; padding: 0 16px !important; font-size: 15px !important; }
.el-button--medium, .el-button--default { height: 40px; padding: 0 22px !important; font-size: 16px !important; }
.el-button span { display: inline-flex; align-items: center; justify-content: center; }
.el-button--primary {
  background: var(--theme-primary) !important;
  border-color: var(--theme-primary) !important;
}
.el-button--primary:hover, .el-button--primary:focus {
  background: var(--theme-primary-hover) !important;
  border-color: var(--theme-primary-hover) !important;
}
.el-button--default:hover {
  color: var(--theme-primary) !important;
  border-color: var(--theme-primary) !important;
  background: var(--theme-primary-light) !important;
}

/* Card header buttons alignment */
.el-card__header .el-button { vertical-align: middle !important; }
.clearfix, .card-header {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
}
.clearfix > div, .card-header > div {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Search bar alignment */
.el-form--inline .el-form-item {
  display: inline-flex !important;
  align-items: center !important;
  vertical-align: middle !important;
  margin-bottom: 12px;
}
.el-form--inline .el-form-item__label {
  line-height: 32px;
}
.el-form--inline .el-form-item__content {
  display: inline-flex !important;
  align-items: center !important;
  line-height: 32px;
}

/* Global form - 老年版加大输入与文字 */
.el-form-item__label { font-size: 16px; color: var(--theme-text); font-weight: 500; }
.el-input__inner { height: 40px !important; line-height: 40px !important; font-size: 15px !important; border-radius: 6px !important; border-color: var(--theme-border) !important; }
.el-input__inner:focus { border-color: var(--theme-primary) !important; }
.el-textarea__inner { font-size: 15px !important; border-color: var(--theme-border) !important; border-radius: 6px !important; }
.el-select .el-input__inner { height: 40px !important; }

/* 链接、tag、菜单激活态 */
.el-tag { font-size: 14px; height: 26px; line-height: 24px; padding: 0 10px; font-weight: 500; }
/* 全局展开区域 dc-label / dc-value 统一 15px */
.dc-label, .dc-value { font-size: 15px !important; }
.el-link--primary, .el-link--primary:hover { color: var(--theme-primary) !important; }

/* 分页 */
.el-pagination .el-pager li.active { background-color: var(--theme-primary) !important; color: #fff !important; }
.el-pagination .el-pager li:hover { color: var(--theme-primary) !important; }

/* checkbox/radio 主题色 */
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner,
.el-radio__input.is-checked .el-radio__inner {
  background-color: var(--theme-primary) !important;
  border-color: var(--theme-primary) !important;
}
.el-checkbox__input.is-checked + .el-checkbox__label,
.el-radio__input.is-checked + .el-radio__label { color: var(--theme-primary) !important; }
.el-switch.is-checked .el-switch__core { border-color: var(--theme-primary) !important; background-color: var(--theme-primary) !important; }

/* Upload button fix */
.el-upload--text .el-button,
.el-upload .el-button {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

/* Pagination alignment */
.el-pagination {
  text-align: right;
  padding: 12px 0 4px;
}
.el-pagination button, .el-pagination .el-pager li {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

/* 字体白色按钮（统一用：全局所有"添加 xxx"类按钮强制白字） */
.el-button.white-text-btn,
.el-button.white-text-btn:hover,
.el-button.white-text-btn:focus { color: #ffffff !important; }

/* 新出库未完结 tag：实心红 + 加粗大字 + 脉冲呼吸光圈 */
.el-tag.newout-uncompleted-tag {
  background-color: #f56c6c !important;
  border-color: #f56c6c !important;
  color: #fff !important;
  font-weight: 700 !important;
  font-size: 14px !important;
  height: 30px !important;
  line-height: 28px !important;
  padding: 0 12px !important;
  letter-spacing: 2px;
  border-radius: 4px !important;
  box-shadow: 0 0 0 0 rgba(245, 108, 108, .6);
  animation: newoutPulse 1.4s ease-in-out infinite;
}
@keyframes newoutPulse {
  0%   { box-shadow: 0 0 0 0   rgba(245, 108, 108, .65); transform: scale(1); }
  50%  { box-shadow: 0 0 0 8px rgba(245, 108, 108, 0);   transform: scale(1.05); }
  100% { box-shadow: 0 0 0 0   rgba(245, 108, 108, 0);   transform: scale(1); }
}

/* Scrollbar */
::-webkit-scrollbar { width: 6px; height: 6px; }
::-webkit-scrollbar-thumb { background: #c0c4cc; border-radius: 3px; }
::-webkit-scrollbar-thumb:hover { background: #909399; }
::-webkit-scrollbar-track { background: transparent; }
</style>
